import React, { Component, Fragment } from "react";
import { API } from "aws-amplify";
import MakePayment from "../../lib/forms/MakePayment";
import PropTypes from "proptypes";
import { readableResponseMessage } from "ux-helpers";

export default class FundRaise extends Component {
  state = {
    trip: null
  };

  componentDidMount() {
    if (this.props && this.props.match && this.props.match.params) {
      const { tripName } = this.props.match.params;
      API.get("give-api", "/user/fundraise/" + tripName, {
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        const payments = {
          deposit: 450,
          addOnsDeposit: 700,
          tripBalance: response[0].tripBalance,
          tripAmount: response[0].tripAmount,
          completedPayments: []
        };
        let trip = response[0];
        trip.payments = payments;
        trip.currentAddOns = [];
        this.setState({
          user: {
            trips: response
          },
          trip,
          payments,
          tripName,
          loaded: true
        });
      })
      .catch(error => {
        this.setState({
          message: readableResponseMessage(error),
          loaded: true
        });
      });
    }
  }

  render() {
    const { user, trip, payments, tripName } = this.state;
    return (
      <Fragment>
        {this.state.trip || this.state.message ? (
          <div className="container">
            {this.state.message ? (
              <div className="row">
                <div className="col-md-2" />
                <div className="col-md-8 center">
                  <h2>{this.state.message}</h2>
                  <div className="center top-margin-xl">
                    <img
                      className="logo"
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFkAAAAyCAMAAAAA5ocEAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABFUExURUdwTA+TAA6SAA6TAA6SAA6TAA+RAA6TAA+TAA6TAA6TAA6SAAqVAA6TAA6SAA6TAA6TAA6TAAySAA6TAA6TAA6TAA+TAPzwOMEAAAAWdFJOUwAvz38+Ww+jHE3nlgWzwHKMZybx+dw7rrKqAAAD+ElEQVRYw7VX2WKrIBBlX0V2/v9T7yCaqo2paXPPgy1LDsPsIPQTuEf/Ca55jPFpcqL9PCX+QjyFBpgRkk7CSE19MpnWKHdNjj1i+g2zKp2ZSAJf600nm1AfdEQ4hMyuOPS+9Nq1A4h3Jtd1YGYS1v9KfEMN1MLXHInbefyA5fweb6rAIRme203kxRg/gfKkTXsfkgqmXnpw+zVKK9e8ptb2F1BOnxP79nfYp8ztE/jmgsJr+h+YsXf5I7TNHHOYaB+DPMU6jp9iLiWfgqaan6LsPvQpYrwp15tdz519vWh+OqdQQ0J55Xn4WmoHUmAqMSTSwhGXrmG6xV0PPL5PiibPR5lxn60XVkHaRq3B1EABxicNZmCCJuSoSvIhAYOU48+1QHiKFWKBkoO0hGuGhJmDUNlNnTSj2Mj2Y8EtZEQSkmYgOIP8i6/rgAhSklwqx5DZR94lbZ4QK4vwrYIi8uIA2C4KDBvX61y30S+7V+rUZVQG1AuXaquxwqKEarn6VYmFFBXAQBQnSK8lE4wWnZI1EUh2l0gkBthrivdqAWI1wjQQph5RpN9DthLSvQrFJRRiGaiPnlr5uCRQy8mj3ARqlCVwsjUxsDsVe+ISTGHsFjsTHFObGTLBvcGWPaFriRUY742mInQLz2eV6ToSIpA1EYPWkfKu5fl250IXWz+r6qBTNlqiihTnoB+IJnOXWCyVP+PnncxS63Wvb0NLcIi+SzzCGV8sy4rWhoaNgGnmripGr0Iv15cje0gUNTbjm8Rs5KsfVYfBU7DcRL8D29Yu9t7Gxm87nLvqEIR6ZINJPJgDmtap/ndaBuObePRxHztuS7/n0EmazoYsmLtqcXdN0lVOnLNadw6stZsl/KsocTZYZ9ocjz2RudLtgqFaGCw5udeHvDMTrNrS/LS9EKo6dAPP7aKWtTo2gszjN8J8qS+vHvOQFNzSHTrP+oLZbOFIttT1aINI98HuXtJaGwDU7NzBX2j6i3lahaFfkTnc2i537QSWeu8jgOFdBmb1ihoPZ9+uOe/LQZ7gy7eQuHqmxF5SDb+Iz3EmPUQq+KDU29gdqY9Rx0IndzE9pgULuRUiPdsFqzp46yMKYGfLlkMx0l66b1VRaTvPztLINYD7IOnq+DhS6xaVFUc1G/VZ213LKViEIhQoDTZchb9K8BZO6fHwFb22nEFkZOhPANp83S2SoNWbD+MEXU8F5JWAazCl3z0HZJDz1rlW6bmG1gpSyXLRlHYJQsOKEkKxGBxZ+bLJOVe4dt+oaK/jXkrpSCckwwKT0hS6KYgSeO5LUqsL0Uv+5RXOSRo1w4zTvgVsqPGLSyqswzxLfmpTwDxKqPSsXZrQR/EPIYiUAgcnH1wAAAAASUVORK5CYII="
                      alt="Dark GIVE tree logo"
                    />
                  </div>
                  <div>
                    <h2>About GIVE</h2>
                    <p className="muted">
                      GIVE offers amazing, once-in-a-lifetime volunteer abroad
                      programs that transform the lives of its volunteers,
                      igniting new passions and inspiring incredible personal
                      growth. Work and play side by side with welcoming locals.
                      Immerse yourself in extraordinary new worlds abroad. Break
                      down cultural barriers and build up lifelong
                      relationships.
                    </p>
                    <p className="muted">
                      Our sustainable development initiatives have a lasting
                      impact on the communities we serve and the volunteers who
                      engage with them. Unlike other volunteer abroad programs
                      our volunteers stay involved long after their experience
                      ends, becoming lifelong global citizens and goodwill
                      ambassadors.
                    </p>
                  </div>
                  <div className="center top-padding">
                    <h5>
                      <a
                        href="https://www.givevolunteers.org"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        www.givevolunteers.org
                      </a>
                    </h5>
                  </div>
                </div>
                <div className="col-md-2" />
              </div>
            ) : (
              <div>
                <div className="row">
                  <div className="col-md-2" />
                  <div className="col-md-8 center">
                    <h2>
                      {tripName.split("-")[0]} is going to {trip.destination} on{" "}
                      {trip.startDate}!
                    </h2>
                    <h3>
                      Please help making this amazing, life-changing experience
                      happen by donating below.
                    </h3>
                  </div>
                  <div className="col-md-2" />
                </div>
                <div className="row">
                  <div className="col-md-6">
                    {(trip.content.videoUrl || trip.content.imageUrl) &&
                    trip.content.description ? (
                      <Fragment>
                        {!trip.content.videoUrl ||
                        trip.content.videoUrl === undefined ? (
                          <img
                            className="trip-image"
                            src={`${trip.content.imageUrl}`}
                            alt={trip.destination}
                          />
                        ) : (
                          <div className="resp-container">
                            <iframe
                              id={trip.content.id}
                              className="resp-iframe"
                              title="add-on video"
                              frameBorder="0"
                              padding="0"
                              margin="0"
                              allowFullScreen
                              allow="autoplay; encrypted-media"
                              src={trip.content.videoUrl.replace(
                                "youtu.be/",
                                "www.youtube.com/embed/"
                              )}
                            />
                          </div>
                        )}
                      </Fragment>
                    ) : (
                      ""
                    )}
                    {trip.content.description ? (
                      <div className="top-padding">
                        <h4 className="trip-description muted">
                          {trip.content.description}
                        </h4>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-md-6">
                    <MakePayment
                      user={user}
                      trip={trip}
                      tripIndex={0}
                      tripId={trip.id}
                      tripName={trip.destination}
                      handleRouting={() => {}}
                      payments={payments}
                      setTripState={() => {}}
                      togglePaymentDetails={() => {}}
                      paymentDetails={() => {}}
                    />
                  </div>
                  <div className="row">
                    <div className="col-md-2" />
                    <div className="col-md-8">
                      <div className="center top-margin-xl">
                        <img
                          className="logo"
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFkAAAAyCAMAAAAA5ocEAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABFUExURUdwTA+TAA6SAA6TAA6SAA6TAA+RAA6TAA+TAA6TAA6TAA6SAAqVAA6TAA6SAA6TAA6TAA6TAAySAA6TAA6TAA6TAA+TAPzwOMEAAAAWdFJOUwAvz38+Ww+jHE3nlgWzwHKMZybx+dw7rrKqAAAD+ElEQVRYw7VX2WKrIBBlX0V2/v9T7yCaqo2paXPPgy1LDsPsIPQTuEf/Ca55jPFpcqL9PCX+QjyFBpgRkk7CSE19MpnWKHdNjj1i+g2zKp2ZSAJf600nm1AfdEQ4hMyuOPS+9Nq1A4h3Jtd1YGYS1v9KfEMN1MLXHInbefyA5fweb6rAIRme203kxRg/gfKkTXsfkgqmXnpw+zVKK9e8ptb2F1BOnxP79nfYp8ztE/jmgsJr+h+YsXf5I7TNHHOYaB+DPMU6jp9iLiWfgqaan6LsPvQpYrwp15tdz519vWh+OqdQQ0J55Xn4WmoHUmAqMSTSwhGXrmG6xV0PPL5PiibPR5lxn60XVkHaRq3B1EABxicNZmCCJuSoSvIhAYOU48+1QHiKFWKBkoO0hGuGhJmDUNlNnTSj2Mj2Y8EtZEQSkmYgOIP8i6/rgAhSklwqx5DZR94lbZ4QK4vwrYIi8uIA2C4KDBvX61y30S+7V+rUZVQG1AuXaquxwqKEarn6VYmFFBXAQBQnSK8lE4wWnZI1EUh2l0gkBthrivdqAWI1wjQQph5RpN9DthLSvQrFJRRiGaiPnlr5uCRQy8mj3ARqlCVwsjUxsDsVe+ISTGHsFjsTHFObGTLBvcGWPaFriRUY742mInQLz2eV6ToSIpA1EYPWkfKu5fl250IXWz+r6qBTNlqiihTnoB+IJnOXWCyVP+PnncxS63Wvb0NLcIi+SzzCGV8sy4rWhoaNgGnmripGr0Iv15cje0gUNTbjm8Rs5KsfVYfBU7DcRL8D29Yu9t7Gxm87nLvqEIR6ZINJPJgDmtap/ndaBuObePRxHztuS7/n0EmazoYsmLtqcXdN0lVOnLNadw6stZsl/KsocTZYZ9ocjz2RudLtgqFaGCw5udeHvDMTrNrS/LS9EKo6dAPP7aKWtTo2gszjN8J8qS+vHvOQFNzSHTrP+oLZbOFIttT1aINI98HuXtJaGwDU7NzBX2j6i3lahaFfkTnc2i537QSWeu8jgOFdBmb1ihoPZ9+uOe/LQZ7gy7eQuHqmxF5SDb+Iz3EmPUQq+KDU29gdqY9Rx0IndzE9pgULuRUiPdsFqzp46yMKYGfLlkMx0l66b1VRaTvPztLINYD7IOnq+DhS6xaVFUc1G/VZ213LKViEIhQoDTZchb9K8BZO6fHwFb22nEFkZOhPANp83S2SoNWbD+MEXU8F5JWAazCl3z0HZJDz1rlW6bmG1gpSyXLRlHYJQsOKEkKxGBxZ+bLJOVe4dt+oaK/jXkrpSCckwwKT0hS6KYgSeO5LUqsL0Uv+5RXOSRo1w4zTvgVsqPGLSyqswzxLfmpTwDxKqPSsXZrQR/EPIYiUAgcnH1wAAAAASUVORK5CYII="
                          alt="Dark GIVE tree logo"
                        />
                      </div>
                      <div>
                        <h2>About GIVE</h2>
                        <p className="muted">
                          GIVE offers amazing, once-in-a-lifetime volunteer abroad
                          programs that transform the lives of its volunteers,
                          igniting new passions and inspiring incredible personal
                          growth. Work and play side by side with welcoming locals.
                          Immerse yourself in extraordinary new worlds abroad. Break
                          down cultural barriers and build up lifelong
                          relationships.
                        </p>
                        <p className="muted">
                          Our sustainable development initiatives have a lasting
                          impact on the communities we serve and the volunteers who
                          engage with them. Unlike other volunteer abroad programs
                          our volunteers stay involved long after their experience
                          ends, becoming lifelong global citizens and goodwill
                          ambassadors.
                        </p>
                      </div>
                    </div>
                    <div className="center top-padding">
                      <h5>
                        <a
                          href="https://www.givevolunteers.org"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          www.givevolunteers.org
                        </a>
                      </h5>
                    </div>
                    <div className="col-md-2" />
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="loader throbber" />
        )}
      </Fragment>
    );
  }
}

FundRaise.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      tripName: PropTypes.string
    })
  })
};

FundRaise.defaultProps = {
  match: {
    params: {
      tripName: ""
    }
  }
};
